// Mitra redirects public ActivityPub object URLs to clean web-client paths.
// When chan-fe is the instance's web_client_dir, translate the paths it owns
// into chan-fe's hash routes before the first view is loaded.
export function hashRouteForServerPath(pathname) {
  const match = String(pathname || "").match(/^\/post\/([^/]+)\/?$/);
  if (!match) return "";

  try {
    const id = decodeURIComponent(match[1]);
    return id ? `#/post/${encodeURIComponent(id)}/` : "";
  } catch {
    return "";
  }
}
